import { useEffect, useState } from "react";

export function useScrollPositionInRef(ref) {
  const [scrollTop, setScrollTop] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const handleScroll = () => {
      setScrollTop(el.scrollTop);
      setScrollLeft(el.scrollLeft);
    };

    el.addEventListener("scroll", handleScroll);

    // posición inicial
    handleScroll();

    return () => el.removeEventListener("scroll", handleScroll);
  }, [ref]);

  return { scrollTop, scrollLeft };
}
